import * as types from './mutation-types'

export const modifyWork = function ({commit}, work) {
  commit(types.SET_ACTIVEHOMEWORK, work)
}

export const modifyHomeWorkList = function ({commit}, list) {
  commit(types.SET_HISTORYWORKLIST, list)
}

export const modifyClassList = function ({commit}, list) {
  commit(types.SET_CLASSLIST, list)
}
export const modifyStuHomework = function ({commit}, work) {
  commit(types.SET_STUHOMEWORK, work)
}
export const modifyPeerwork = function ({commit}, list) {
  commit(types.SET_PEERWORKLIST, list)
}
export const modifyPeertask = function ({commit}, list) {
  commit(types.SET_PEERTASK, list)
}
export const modifyMarks = function ({commit}, list) {
  commit(types.SET_MARK, list)
}
export const setAttach = function ({commit}, model) {
  commit(types.SET_ATTACH, model)
}
export const setCourseRole = function ({commit}, model) {
  commit(types.SET_COURSEROLE, model)
}



// WEBPACK FOOTER //
// ./src/store/actions.js